import { action, flow, makeObservable, observable } from "mobx";
import { DocumentSigningService } from "../../services/documentForms/documentSigningService";
import { GlobalStore } from "@roc/feature-app-core";
import { downloadDocument } from "@roc/feature-utils";
import { DocumentService } from "../../services/documentService";

export class DocumentSigningStore {
  private globalStore: GlobalStore;
  documentSigningService: DocumentSigningService;
  documentService: DocumentService;
  noteAllongeErrorMessage: string;
  assignmentAndConveyanceErrorMessage: string;
  wetSignTrackingNumber: string;
  wetSignMailingAddress: string[];

  constructor(globalStore) {
    this.globalStore = globalStore;
    this.documentSigningService = new DocumentSigningService();
    this.documentService = new DocumentService();
    makeObservable(this, {
      wetSignTrackingNumber: observable,
      wetSignMailingAddress: observable,
      fetchWetSignMailingAddress: flow,
      setWetSignTrackingNumber: action,
      downloadWetSignDocument: flow,
      saveWetSignTrackingNumber: flow,
      generateNoteAllongeDocument: flow,
      generateAssignmentAndConveyanceDocument: flow,
      validateNoteAllongeDocument: flow,
      validateAssignmentAndConveyanceDocument: flow,
    });
    this.setDefaults();
  }

  setDefaults() {
    this.wetSignTrackingNumber = '';
    this.wetSignMailingAddress = [];
  }

  setWetSignTrackingNumber(trackingNumber: string) {
    this.wetSignTrackingNumber = trackingNumber;
  }

  *generateNoteAllongeDocument(signature, loanId) {
    try {
      const data = {
        loanId,
        signature,
        userAgent: navigator.userAgent,
      }
      yield this.documentSigningService.generateNoteAllongeDocument(data);
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Succesfully signed Note Allonge document.',
      });
    }
    catch (error) {
      console.log(error);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while generating Note Allonge document.',
      });
    }

  }

  *generateAssignmentAndConveyanceDocument(signature, loanId) {
    try {
      const data = {
        loanId,
        signature,
        userAgent: navigator.userAgent,
      }
      yield this.documentSigningService.generateAssignmentAndConveyanceDocument(data);
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Succesfully signed Assignment and Conveyance document.',
      });
    }
    catch (error) {
      console.log(error);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while generating Assignment and Conveyance document.',
      });
    }
  }

  *validateNoteAllongeDocument(loanId) {
    try {
      const response = yield this.documentSigningService.validateSigningDocument(loanId);
      this.noteAllongeErrorMessage = response?.data?.data?.errorMessage;
    } catch(error) {
      console.log(error);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while opening Note Allonge.',
      });
    }
  }

  *validateAssignmentAndConveyanceDocument(loanId) {
    try {
      const response = yield this.documentSigningService.validateSigningDocument(loanId);
      this.assignmentAndConveyanceErrorMessage = response?.data?.data?.errorMessage;
    } catch(error) {
      console.log(error);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while opening Assignment and Conveyance.',
      });
    }
  }

  // where the wet-signed originals are mailed, kept in nportal WetSignService (also used by the wet-sign email)
  *fetchWetSignMailingAddress() {
    try {
      const response = yield this.documentSigningService.getWetSignMailingAddress();
      this.wetSignMailingAddress = response?.data?.data ?? [];
    } catch (error) {
      console.log(error);
      this.wetSignMailingAddress = [];
    }
  }

  *downloadWetSignDocument(loanId, documentType: string) {
    try {
      const response = yield this.documentSigningService.downloadWetSignDocument(loanId, documentType);
      downloadDocument(response?.data, response?.headers, 'download');
    } catch (error) {
      console.log(error);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while downloading the document.',
      });
    }
  }

  // the FedEx tracking number is kept in the wet-sign task's description, saving it completes the task
  *saveWetSignTrackingNumber(taskId: number) {
    try {
      yield this.documentService.updateTaskDescription(taskId, this.wetSignTrackingNumber?.trim());
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Tracking number saved successfully.',
      });
      return true;
    } catch (error) {
      console.log(error);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while saving the tracking number.',
      });
      return false;
    }
  }

}
